import script from "./ho-modal-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ho-modal-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./ho-modal-dialog.vue?vue&type=style&index=0&id=0658fd2c&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0658fd2c"]])

export default __exports__